import { createContext } from 'react';
import { UIStore } from './uiStore';
import ConfigStore from './configStore';
import AccountStore from './AccountStore';
import kioskStore from './kioskStore';
import SessionStore from './sessionStore';
import ReceiptStore from './ReceiptStore';
import BPKManagerStore from './BPKManagerStore';

interface Store {
	accountStore: AccountStore;
	configStore: ConfigStore;
	uiStore: UIStore;
	kioskStore: kioskStore;
	sessionStore: SessionStore;
	receiptStore: ReceiptStore;
	bpkManagerStore: BPKManagerStore;
}

const uiStore = new UIStore();

export const store: Store = {
	accountStore: new AccountStore(),
	configStore: new ConfigStore(),
	uiStore,
	kioskStore: new kioskStore(),
	sessionStore: new SessionStore(),
	receiptStore: new ReceiptStore(),
	bpkManagerStore: new BPKManagerStore(),
};

export const StoreContext = createContext(store);
